import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { URL_MAIN_PAGE, URL_PAGE_CATALOG } from '@shared/contants'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

type ActionButtonType = {
  title: string;
  onClick: () => void;
}

type NotFoundComponentProps = {
  title?: string;
  description?: string;
  buttons?: ActionButtonType[]; 
};

export default function NotFoundComponent ({
  title,
  description,
  buttons = [],
}: NotFoundComponentProps) {
  const isTablet = useMediaQuery('(max-width: 1247px)')
  const { t: t } = useTranslation('common')

  return (
    <div className={styles.root}>
      <div className={styles.root__content}>
        <span className={styles.root__number}>
          404
        </span>
        <h2>{title ?? t('no-match-title')}</h2>
        <p
          dangerouslySetInnerHTML={{
            __html: description ?? t('no-match-description'),
          }}
        />
        { buttons.length > 0 ? (
          <div className={styles.root__buttons}>
            { buttons.map((button, index) => (
              <Button
                key={index}
                onClick={button.onClick}
                size={!isTablet ? 'large' : 'medium'}
              >
                {button.title}
              </Button>
            )) }
          </div>
        ) : (
          <div className={styles.root__buttons}>
            <Button to={URL_PAGE_CATALOG} size={!isTablet ? 'large' : 'medium'}>
              {t('button.catalog')}
            </Button>
            <Button to={URL_MAIN_PAGE} size={!isTablet ? 'large' : 'medium'} theme="grey">
              {t('button.main')}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}